import MultiChoiceItem from '../../../types/MultiChoiceItem';

export default (data: MultiChoiceItem[]): string[] => (
  data.filter(({ checked }) => checked).map(({ id }) => id)
);
